import React from 'react';
import { BaseComponent } from './BaseComponent.js';
import { NavLink  } from 'react-router-dom';

export class LeftSidebar extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = { user: this.getUser() };
  }

  getUser() {
    let val = this.readCookie('unithings_user');
    if (val != null) {
      return val;
    }
    return '';
  }

  render() {
    return (
      <div className={ this.props.classMenu }>
        <div className="left-sidebar__user">{ this.state.user }</div>
        <ul className="left-sidebar__menu">
          <li className="left-sidebar__menu__el">
            <NavLink exact={true} to="/" className="left-sidebar__menu__el__link" activeClassName="is-active">Dashboard</NavLink>
            <NavLink exact={true} to="/devices" className="left-sidebar__menu__el__link" activeClassName="is-active">Dispositivi</NavLink>
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LeftSidebar.js